"use strict";

/**
 * @classdesc
 * Gruppiert die aktuell ausgewählten Layer unterhalb der tiefstmöglichen
 * gemeinsamen Elterngruppe.
 *
 * @class
 * @extends gc.gis.action.GCAbstractAction
 * @memberof gc.gis.action.layer
 * @author Anton Popov <a.popov@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {gc.gis.map.GCMapView} options.map Referenz auf die Karte der Layer
 */
gc.gis.action.layer.GroupSelection = function( options )
{
	gc.gis.action.GCAbstractAction.call( this );

	/**
	 * @inheritdoc
	 */
	this.func = this.doGroup;
	/**
	 * @inheritdoc
	 */
	this.args = [options.map];
};
gc.gis.action.layer.GroupSelection.prototype = Object.create( gc.gis.action.GCAbstractAction.prototype );

/**
 * Gruppiert die aktuell ausgewählten Layer.
 * <em>Hinweis: Diese Funktion sollte nicht manuell aufgerufen werden.</em>
 *
 * @public
 * @param {gc.gis.map.GCMapView} map Referenz auf die Karte
 * @throws gc.gis.error.GCError wenn kein Layer ausgewählt ist oder das
 *   Gruppieren schief geht
 * @see gc.gis.action.GCAbstractAction#execute
 */
gc.gis.action.layer.GroupSelection.prototype.doGroup = function(map)
{
	var layers = map.getSelectedLayers();

	if(layers && layers.length)
	{
		var error_count = 0;
		var path;

		// Gruppe erstellen
		var new_parent = gc.gis.GCUtil.findCommonParent(layers);
		var group = new gc.gis.layer.GCGroupLayer({
			label: 'Neue Gruppe',
            expanded: true,
			visible: true
		});
        new_parent.addLayer(group);

		try
		{
			path = group.getIndex();
			path.push(0);
			map.moveLayerList(layers, path);
		}
		catch(err)
		{
			gc.gis.iface.log.error(this, err);
			error_count++;
		}

		// Benachrichtigen
		if(error_count === 0)
		{
			gc.gis.iface.ui.notify({
				type: gc.gis.ui.GCNotificationType.INFO,
				message: 'Gruppe "'+ group.getLabel() +'" erstellt.'
			});
			map.selectNone();	// Auswahl aufheben
		}
		else
		{
			gc.gis.iface.ui.notify({
				type: gc.gis.ui.GCNotificationType.ERROR,
				message: 'Gruppe "'+ group.getLabel() +'" konnte nur teilweise erstellt werden.'
			});
		}
	}
	else
	{
		gc.gis.iface.log.warn( this, 'Keine Ebenen ausgewählt!');
		//throw new gc.gis.error.GCError('Nothing selected');
	}
};

